// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3oiC2","error":"Textarea_error__1fcTz","readonly":"Textarea_readonly__2qPCF","disabled":"Textarea_disabled__2GLMQ"};